const location = {
  // 接口域名
  domain () {
    let URL = window.location.origin
    // URL = 'https://pxcs.teacheredu.cn'
    // URL = 'https://pxcspub.teacheredu.cn'
    // URL = 'https://px.teacheredu.cn'
    return URL + '/'
  },
  // 静态资源域名
  static () {
    let URL = this.domain() + 'static/';
    return URL;
  },
  // 三级页域名
  html () {
     let URL = this.domain() + 'html/';
    return URL;
  },
  // 文件域名
  files () {
    let URL = this.domain() + 'files/';
    return URL;
  },
  //包含http/https图片的情况
  hfiles (url) {
    if(!url) {
      return
    }
    let URL = url.startsWith('http') ? url : this.domain() + 'files/' + url;
    return URL;
  },
  authorization() {
    return '';
  }
};

export default location;

